import { border, space } from "@smartsheet/design-tokens";
import { color } from "@smartsheet/design-tokens-react";
import { themed } from "@smartsheet/sds-theme-internal";
import { shadows } from "../../../constants/layers";
import { sizes } from "../../../constants/spacing";

export const modalTheme = themed({
    actionsPadding: {
        "lodestar-light": `${sizes.small}px ${sizes.small}px 0`,
        "ursa-light": `${space.space50} ${space.space50} 0`,
    },
    backgroundColor: color("color--background--surfaces--work"),
    boxShadow: {
        "lodestar-light": `${shadows.modal()}`,
        "ursa-light": color("elevation--high"),
    },
    bodyGutter: {
        "lodestar-light": "legacy",
        "ursa-light": "space60",
    },
    borderRadius: {
        "lodestar-light": "0px",
        "ursa-light": border.radius50,
    },
    color: color("color--text--neutral--strong"),
});
